export default __webpack_public_path__ + "static/media/ico-wifi.7b7bf346.svg";